import { getResolvedRef } from '../../helpers/get-resolved-ref.js';
import { coerceValue } from '../../schemas/typebox-coerce.js';
import { SchemaObjectSchema } from '../../schemas/v3.2/strict/openapi-document.js';
import { getXmlExampleFromSchema, serializeXmlExample } from './get-xml-example.js';
/** Resolve media-level XML examples without treating schema string values as serialized payloads. */
export const getXmlBodyExample = (schema, inputExample, options = {}) => {
    const example = getResolvedRef(inputExample);
    if (example?.serializedValue !== undefined) {
        return { xml: example.serializedValue, diagnostics: [] };
    }
    if (example?.dataValue !== undefined) {
        return serializeXmlExample(example.dataValue, schema ?? coerceValue(SchemaObjectSchema, {}), options);
    }
    if (typeof example?.value === 'string') {
        return { xml: example.value, diagnostics: [] };
    }
    if (example?.value !== undefined) {
        return serializeXmlExample(example.value, schema ?? coerceValue(SchemaObjectSchema, {}), options);
    }
    return schema ? getXmlExampleFromSchema(schema, options) : { xml: undefined, diagnostics: [] };
};
